export const SessionEventType = ({ eventType }) => {
    let result;
    switch (eventType) {
        case 0: result = <span className="text-info">Список гостей</span>;
            break;
        case 1: result = <span className="text-info">Мероприятие с экспресс тестом</span>;
            break;
        case 2: result = <span className="text-info">ПЦР Тест</span>;
            break;
        case 3: result = <span className="text-info">Список гостей на шоу</span>;
            break;
        case 4: result = <span className="text-info">Мероприятие с экспресс тестом (С кабинками)</span>;
            break;
        case 5: result = <span className="text-info">Драйв-шоу</span>;
            break;
        case 6: result = <span className="text-info">Мероприятие с экспресс тестом (С кабинками + столы)</span>;
            break;
        case 7: result = <span className="text-info">Список гостей (с доп.комментариями)</span>
            break;
        default: result = <span>Некорректные данные</span>
    }
    return result;
}